<template>
	<div>

	</div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
    let login_token = this.$route.query.token;
    let assitantParam = this.$route.query.assitantParam;
    //有些客服，（比如辽宁的局部地区），访问 t.itaojin.cn/train/index时，某缓存js（https://t-cdn.itaojin.cn/tjkStudy/static/js/9.dc86dfbdcc303ae07f9a.js）， 用http访问不到，用https能行，所以下面访问的时候强行指定为https，否则白屏
    var url = window.location.origin.indexOf('itaojin.cn') > -1 ? 'https://t.itaojin.cn' : 'https://t.itaojintest.cn';
	  if(assitantParam == 'SkillUpgrade'){
	      var url = window.location.origin + '/customer/action/login/verifyLogin?url='+url+'/tjkStudy/train/index?type=SkillUpgrade&show=yes&token=' + login_token;
          window.location.href = url;
	  }else {
          window.location.href = window.location.origin + '/customer/action/login/verifyLogin?url='+url+'/tjkStudy/train/index&token=' + login_token;
      }
  },
  methods: {
  	
  } 
}
</script>


// WEBPACK FOOTER //
// ./src/page/train/blankLogin.vue